import React from "react";
import {
  Autocomplete,
  Button,
  Grid,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { useStyles } from "./styles";
import { ErrorMessage, Formik } from "formik";
import { useNavigate, useOutletContext } from "react-router-dom";
import useCourse from "../../../../Hooks/course";
import Loader from "../../../../common/Loader";
import CustomExpandMore from "../../../../common/CustomExpandMore";
import { Modal } from "@material-ui/core";
import { color } from "../../../../assets/const/color";
import * as Yup from "yup";
import useSuperAdminConfiguration from "../../../../Hooks/configuration";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: color.white,
  borderRadius: "25px",
  p: 4,
};
const FormSchema = Yup.object().shape({
  idInstitution: Yup.string().required("* Please choose institution"),
  idFunctionalities: Yup.string().required("* Please choose functionalities"),
  enabled: Yup.boolean().required("* Please set status"),
});
const initValues = {
  idInstitution: "",
  idFunctionalities: "",
  enabled: false,
};
const label = { inputProps: { "aria-label": "Enabled" } };

const InsertFuncionalities = (props) => {
  const { setOpen, open, handleClose } = props;
  const classes = useStyles();
  const {
    institutionsData,
    allfunctionalitiesData,
    insertFuncionalitiesAction,
  } = useSuperAdminConfiguration();

  const {
    getActiveCourseData,
    updateCourseAction,
    loading,
    departmentData,
    programData,
  } = useCourse();

  const navigate = useNavigate();
  return (
    <>
      {loading && <Loader />}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={classes.root}
      >
        <Stack sx={style}>
          <Typography sx={{ py: 2 }} className={classes.add_course_text}>
            Add Functionalities
          </Typography>
          <Grid container>
            <Grid item lg={10} sm={12}>
              <Stack>
                <Formik
                  initialValues={initValues}
                  validationSchema={FormSchema}
                  validateOnBlur={false}
                  validateOnChange={false}
                  onSubmit={(values) => {
                    insertFuncionalitiesAction({
                      ...values,
                    });
                  }}
                >
                  {(formik) => {
                    const {
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                      values,
                    } = formik;
                    return (
                      <form onSubmit={handleSubmit}>
                        <Grid
                          container
                          className={classes.form_add_course}
                          justifyContent="space-between"
                        >
                          <Grid item lg={12} md={12} sx={{ width: "100%" }}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                pb: 3,
                              }}
                            >
                              <Stack>
                                <Typography
                                  sx={{ pb: 1 }}
                                  className={classes.input_label}
                                >
                                  Institutions
                                </Typography>
                              </Stack>
                              <Stack sx={{ width: "80%", ml: 1 }}>
                                <Autocomplete
                                  id="idInstitution"
                                  name="idInstitution"
                                  options={institutionsData || []}
                                  getOptionLabel={(option) => option.name}
                                  popupIcon={<CustomExpandMore />}
                                  onChange={(e, newValue) => {
                                    setFieldValue("idInstitution", newValue.id);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Institution"
                                    />
                                  )}
                                  renderOption={(props, option) => {
                                    return (
                                      <li {...props} key={option.id}>
                                        {option.name}
                                      </li>
                                    );
                                  }}
                                  className={
                                    errors.idInstitution &&
                                    touched.idInstitution
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                />
                                <ErrorMessage
                                  name="idInstitution"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item lg={12} md={12} sx={{ width: "100%" }}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                pb: 3,
                              }}
                            >
                              <Stack>
                                <Typography
                                  sx={{ pb: 1 }}
                                  className={classes.input_label}
                                >
                                  Functionalities
                                </Typography>
                              </Stack>
                              <Stack sx={{ width: "80%", ml: 1 }}>
                                <Autocomplete
                                  id="idFunctionalities"
                                  name="idFunctionalities"
                                  options={allfunctionalitiesData || []}
                                  getOptionLabel={(option) => option.name}
                                  popupIcon={<CustomExpandMore />}
                                  onChange={(e, newValue) => {
                                    console.log("idFunctionalities", newValue);
                                    setFieldValue(
                                      "idFunctionalities",
                                      newValue.id
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Functionalities"
                                    />
                                  )}
                                  renderOption={(props, option) => {
                                    return (
                                      <li {...props} key={option.id}>
                                        {option.name}
                                      </li>
                                    );
                                  }}
                                  className={
                                    errors.idFunctionalities &&
                                    touched.idFunctionalities
                                      ? classes.inputError
                                      : classes.inputNoError
                                  }
                                />
                                <ErrorMessage
                                  name="idFunctionalities"
                                  component="span"
                                  className={classes.error}
                                />
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item lg={12} md={12} sx={{ width: "100%" }}>
                            <Stack
                              sx={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                pb: 3,
                              }}
                            >
                              <Stack>
                                <Typography
                                  sx={{ pb: 1 }}
                                  className={classes.input_label}
                                >
                                  Enabled
                                </Typography>
                              </Stack>
                              <Stack sx={{ width: "80%", ml: 1 }}>
                                <Switch
                                  onChange={handleChange}
                                  {...label}
                                  defaultChecked
                                  color="success"
                                  name={"enabled"}
                                  checked={values.enabled}
                                />
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid container sx={{ py: 4 }}>
                            <Stack
                              sx={{
                                justifyContent: "end",
                              }}
                              spacing={2}
                              direction="row"
                              justifyContent={"end"}
                            >
                              <Button
                                type="submit"
                                sx={{
                                  px: 1,
                                  py: 1,
                                  borderRadius: "50px",
                                }}
                                className={classes.add_course_btn}
                              >
                                Add
                              </Button>
                              <Button
                                type="reset"
                                sx={{ px: 1, py: 1, borderRadius: "50px" }}
                                className={classes.cancel_btn}
                                onClick={() => handleClose()}
                              >
                                Cancel
                              </Button>
                            </Stack>
                          </Grid>
                        </Grid>
                      </form>
                    );
                  }}
                </Formik>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </Modal>
    </>
  );
};

export default InsertFuncionalities;
